<template>
    <div :id="dataInfo.type" ref="type" style="width: 100%; height: 100%;"></div>
</template>

<script>
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/title');
    require('echarts/lib/component/toolbox');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/chart/pie');
    export default {
        name: "DataView",
        props: {
            data: {
                type: Array,
                default() { return [] }
            },
            dataInfo: {
                default() {
                    return {}
                }
            },
            // 金额口径：true 时图例 / 提示按「¥ + 千分位」展示（订单统计用）；
            // 不传则保持原样，不影响课时统计等页面。
            money: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.drawLine();
            window.addEventListener('resize', this.resizeChart)
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.resizeChart)
            if (this.chart) {
                this.chart.dispose()
                this.chart = null
            }
        },
        watch: {
            data() {
                this.drawLine();
            }
        },
        methods: {
            resizeChart() {
                if (this.chart) this.chart.resize()
            },
            fmtNumber(v) {
                const n = Number(v)
                return isNaN(n) ? v : n.toLocaleString('zh-CN')
            },
            drawLine() {
                let that = this;
                if (!this.$refs.type) return;
                if (!this.chart) {
                    this.chart = echarts.init(this.$refs.type)
                } else {
                    this.chart.clear()
                }
                let myChart = this.chart;
                const money = this.money;
                const unit = money ? '¥' : '';
                myChart.off('click')
                // 绘制图表
                myChart.setOption({
                    tooltip: {
                        triggerOn: "mousemove",
                        showContent: true,
                        borderWidth: 1,
                        formatter: function (p) {
                            if (!p) return ''
                            const val = that.fmtNumber(p.value)
                            return p.name + '<br/>' + (money ? '¥ ' : '') + val + '（' + p.percent + '%）'
                        }
                    },
                    legend: {
                        type: 'scroll', //分页类型
                        pageIconColor: '#ff781f', //翻页箭头颜色
                        pageTextStyle: {
                            color: '#999', //翻页数字颜色
                        }, //翻页数字设置
                        pageIconSize: 13,
                        orient: 'vertical',
                        x: this.dataInfo.location || 'left',
                        y: 'center',
                        itemWidth: 10,
                        itemHeight: 10,
                        itemGap: 10,
                        formatter: function (name) {
                            var data = that.data || [];
                            var total = 0;
                            var tarValue = 0;
                            for (var i = 0; i < data.length; i++) {
                                total += Number(data[i].value) || 0;
                                if (data[i].name == name) {
                                    tarValue = Number(data[i].value) || 0;
                                }
                            }
                            var p = total ? Math.round(((tarValue / total) * 100)) : 0;
                            if (!p) p = 0
                            return name + '  ' + unit + that.fmtNumber(tarValue) + ' (' + p + '%)';
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: [24, 150],
                            center: this.dataInfo.center,
                            roseType: 'area',
                            avoidLabelOverlap: true,
                            itemStyle: {
                                borderRadius: 8
                            },
                            data: this.data
                        }
                    ]
                })
                myChart.on('click', function (params) {
                    that.$emit('detailed', params.data);
                })
            },
        }
    }
</script>

<style scoped>

</style>
